import { render, staticRenderFns } from "./navigation3.vue?vue&type=template&id=50abb518&scoped=true"
import script from "./navigation3.vue?vue&type=script&lang=js"
export * from "./navigation3.vue?vue&type=script&lang=js"
import style0 from "./navigation3.vue?vue&type=style&index=0&id=50abb518&prod&lang=less&scoped=true"
import style1 from "./navigation3.vue?vue&type=style&index=1&id=50abb518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50abb518",
  null
  
)

export default component.exports